import React from 'react';
import DOMPurify from 'dompurify';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useAuth } from '../../../contexts/userContext/userContext';
import getPromotion from '../../../../utils/functions/ridePromotions/getPromotion';

function RidePromotion({
  start_station_code,
  end_station_code,
  type,
}) {
  const { currentLanguage } = useTranslation();
  const { ticketBookingOptions: { ridePromotions } } = useAuth();
  const promotion = getPromotion({
    start_station_code,
    end_station_code,
    locale: currentLanguage,
    ridePromotionsMap: ridePromotions,
    type,
  });

  return promotion?.content && (
  // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(promotion.content) }} />
  );
}

export default RidePromotion;
